// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-home-layer {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: stretch;
  align-content: stretch;
  overflow-y: auto;
  height: fit-content;
  position: relative;
}
wm-home-layer wm-img,
wm-home-layer .wm-description {
  margin: 10px;
}
wm-home-layer wm-img.wm-home-layer-logo-overlay {
  position: absolute;
  bottom: 8px;
  right: 8px;
  width: 56px;
  height: 56px;
  min-width: 56px;
  min-height: 56px;
  margin: 0;
  border-radius: 4px;
  overflow: hidden;
  z-index: 2;
}
wm-home-layer .wm-box-title {
  font-size: 26px;
  font-family: var(--wm-font-family-content, inherit);
  font-style: normal;
  font-weight: 700;
  color: white;
  position: absolute;
  bottom: 0;
  padding: 6%;
  line-height: 31px;
  letter-spacing: 0em;
  text-align: left;
  white-space: break-spaces;
}
wm-home-layer .wm-description {
  max-height: 200px;
  overflow: auto;
}
wm-home-layer .wm-home-layer-favorite {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 44px;
  height: 44px;
  min-width: 44px;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.85);
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.35);
  z-index: 3;
  cursor: pointer;
  font-size: 22px;
  color: var(--wm-color-favorite, #d7263d);
}
wm-home-layer .wm-home-layer-favorite--disabled {
  opacity: 0.5;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/home/home-layer/home-layer.component.scss","webpack://./src/app/shared/wm-core/projects/wm-core/src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,2BAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AADF;AAEE;;EAEE,YAAA;AAAJ;AAEE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;AAAJ;AAEE;EACE,eAAA;EACA,mDAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EAEA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;AADJ;AAGE;EACE,iBAAA;EACA,cAAA;AADJ;AAGE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EC/CF,2CAAA;EACA,uCAAA;EDgDE,UAAA;EACA,eAAA;EACA,eAAA;EACA,wCAAA;AAAJ;AAEI;EACE,YAAA;EACA,oBAAA;AAAN","sourcesContent":["@import '../../theme/mixins.scss';\n\nwm-home-layer {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: stretch;\n  align-content: stretch;\n  overflow-y: auto;\n  height: fit-content;\n  position: relative;\n  wm-img,\n  .wm-description {\n    margin: 10px;\n  }\n  wm-img.wm-home-layer-logo-overlay {\n    position: absolute;\n    bottom: 8px;\n    right: 8px;\n    width: 56px;\n    height: 56px;\n    min-width: 56px;\n    min-height: 56px;\n    margin: 0;\n    border-radius: 4px;\n    overflow: hidden;\n    z-index: 2;\n  }\n  .wm-box-title {\n    font-size: 26px;\n    font-family: var(--wm-font-family-content, inherit);\n    font-style: normal;\n    font-weight: 700;\n    color: white;\n    position: absolute;\n    bottom: 0;\n    padding: 6%;\n\n    line-height: 31px;\n    letter-spacing: 0em;\n    text-align: left;\n    white-space: break-spaces;\n  }\n  .wm-description {\n    max-height: 200px;\n    overflow: auto;\n  }\n  .wm-home-layer-favorite {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    width: 44px;\n    height: 44px;\n    min-width: 44px;\n    min-height: 44px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    @include overlay-chip-background;\n    z-index: 3;\n    cursor: pointer;\n    font-size: 22px;\n    color: var(--wm-color-favorite, #d7263d);\n\n    &--disabled {\n      opacity: 0.5;\n      pointer-events: none;\n    }\n  }\n}\n","@mixin box-shadow-light {\n  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.1);\n}\n\n@mixin box-shadow-dark {\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.4);\n}\n\n// Sfondo bianco translucido + ombra leggera per badge/logo/cuoricino overlay\n// su foto (layer-box, home-layer) — stesso pattern ripetuto identico in\n// 4 punti tra i due componenti prima di essere estratto qui (oc:8305).\n@mixin overlay-chip-background {\n  background-color: rgba(255, 255, 255, 0.85);\n  box-shadow: 0 0 4px rgba(0, 0, 0, 0.35);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
